import { BigNumber } from "bignumber.js";
import { FontFaceSetLoadStatus } from "css-font-loading-module";
import { configure } from "enzyme";
import Adapter from "enzyme-adapter-react-16";

configure({ adapter: new Adapter() });

// @ts-ignore
global.BigNumber = BigNumber; // Pro správné fungování BigNumberProxy je nutné globálně definovat BigNumber.

class ResizeObserver {
    public observe(): void { /* Prázdná arrow funkce */ }
    public unobserve(): void { /* Prázdná arrow funkce */ }
    public disconnect(): void { /* Prázdná arrow funkce */ }
}

const mockIterableIteratorFontFace = {} as IterableIterator<FontFace>;

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
class FontFaceSet {
    public onloading(): void { /* Prázdná arrow funkce */ }
    public onloadingdone(): void { /* Prázdná arrow funkce */ }
    public onloadingerror(): void { /* Prázdná arrow funkce */ }
    public addEventListener(): void { /* Prázdná arrow funkce */ }
    public removeEventListener(): void { /* Prázdná arrow funkce */ }
    public forEach(): void { /* Prázdná arrow funkce */ }
    public clear(): void { /* Prázdná arrow funkce */ }
    public check(): boolean {
        return true;
    }
    public dispatchEvent(): boolean {
        return true;
    }
    public delete(): boolean {
        return true;
    }
    public has(): boolean {
        return true;
    }
    public size: number = 1;
    public add(): FontFaceSet {
        return {} as FontFaceSet;
    }
    public prototype: FontFaceSet = {} as FontFaceSet;
    public ready: Promise<FontFaceSet> = new Promise(() => {});
    public load(): Promise<FontFace[]> {
        return Promise.resolve({} as FontFace[]);
    }
    public entries: () => IterableIterator<[FontFace, FontFace]> = () => ({} as IterableIterator<[FontFace, FontFace]>);
    public keys: () => typeof mockIterableIteratorFontFace = () => mockIterableIteratorFontFace;
    public values: () => typeof mockIterableIteratorFontFace = () => mockIterableIteratorFontFace;
    [Symbol.iterator](): typeof mockIterableIteratorFontFace {
        return mockIterableIteratorFontFace;
    }
    [Symbol.toStringTag]: string = Symbol().toString();
    public status: FontFaceSetLoadStatus = "loaded";
}

global.ResizeObserver = ResizeObserver; // V prostředí testů není ResizeObserver dostupný
document.fonts = new FontFaceSet(); // V prostředí testů není FontFace dostupný
